"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env_1 = require("./env");
var ANALYTICS_LOG = Symbol('ANALYTICS_LOG');
if (env_1.NODE_ENV === 'test') {
    global[ANALYTICS_LOG] = global[ANALYTICS_LOG] || {
        identity: null,
        events: {},
    };
}
// This will be `undefined` unless running with NODE_ENV === "test"
var log = global[ANALYTICS_LOG];
var MockAnalyticsStore = {
    /**
     * Record a call to `identify`
     *
     * **Internal use only**
     */
    _recordIdentify: function (userId, traits) {
        if (env_1.NODE_ENV === 'test') {
            log.identity = { userId: userId, traits: traits || null };
        }
    },
    /**
     * Record a call to `track`
     *
     * **Internal use only**
     * @param event event name
     * @param properties event properties
     */
    _recordTrack: function (event, properties) {
        if (properties === void 0) { properties = {}; }
        if (env_1.NODE_ENV === 'test') {
            var events = log.events[event] || [];
            events.push(properties);
            log.events[event] = events;
        }
    },
    /**
     * Returns the `userId` from the last call to `analytics.identify()
     */
    currentUserId: function () {
        if (env_1.NODE_ENV !== 'test')
            throw new Error('You cannot use MockAnalyticsStore outside of tests');
        return log.identity && log.identity.userId;
    },
    /**
     * Returns the `traits` from the last call to `analytics.identify()`
     */
    currentUserTraits: function () {
        if (env_1.NODE_ENV !== 'test')
            throw new Error('You cannot use MockAnalyticsStore outside of tests');
        return log.identity && log.identity.traits;
    },
    /**
     * Returns `true` if an event has been recorded
     */
    hasEvent: function (event) {
        if (env_1.NODE_ENV !== 'test')
            throw new Error('You cannot use MockAnalyticsStore outside of tests');
        return !!log.events[event];
    },
    hasEventWithProperty: function (event, propertyKey, propertyValue) {
        if (env_1.NODE_ENV !== 'test')
            throw new Error('You cannot use MockAnalyticsStore outside of tests');
        if (!MockAnalyticsStore.hasEvent(event))
            return false;
        var events = log.events[event] || [];
        return !!events.find(function (p) { return p[propertyKey] === propertyValue; });
    },
    hasEventWithProperties: function (event, properties) {
        if (env_1.NODE_ENV !== 'test')
            throw new Error('You cannot use MockAnalyticsStore outside of tests');
        if (!MockAnalyticsStore.hasEvent(event))
            return false;
        var events = log.events[event] || [];
        return !!events.find(function (p) {
            for (var _i = 0, _a = Object.keys(properties); _i < _a.length; _i++) {
                var key = _a[_i];
                if (properties[key] !== p[key])
                    return false;
            }
            return true;
        });
    },
    reset: function () {
        log.identity = null;
        log.events = {};
    },
};
exports.default = MockAnalyticsStore;
